import { IFollow } from 'shared/interfaces'

export const isProjectFollowed = (campaignId: string, userFollows?: IFollow[]): boolean => {
  if (!userFollows) return false

  return userFollows.map((item) => item.campaign_id).includes(campaignId)
}

export const followButtonLabel = (isFollowing: boolean, isOwner: boolean): string => {
  if (isOwner) return 'Owner'

  return isFollowing ? 'Following' : 'Follow'
}
